import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@material-ui/core";

const SimpleTextDialog = ({
  title,
  body,
  closeDialog,
  showDialog,
  isModal
}) => (
  <Dialog open={showDialog} modal={isModal} onClose={closeDialog}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        <div style={{ whiteSpace: "pre" }}>{body}</div>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button color="primary" onClick={closeDialog}>
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

SimpleTextDialog.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  closeDialog: PropTypes.func.isRequired,
  showDialog: PropTypes.bool.isRequired,
  isModal: PropTypes.bool
};

SimpleTextDialog.defaultProps = {
  isModal: false
};

export default SimpleTextDialog;
